import React from "react";

export default React.memo(() => <svg viewBox="0 0 4608 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2517" width="200" height="200"><path d="M896 448a448 448 0 1 1-896 0 448 448 0 0 1 896 0zM2240 0a448 448 0 1 1 0 896 448 448 0 0 1 0-896zM4480 448a448 448 0 1 0-896 0 448 448 0 0 0 896 0z" fill="#000000" fill-opacity=".9" p-id="2518"></path></svg>)
